export default __webpack_public_path__ + "static/media/44.236f4531.png";